import { dateToISO } from '../helpers/filters'
import store from '../store'

export default class MailingModel {
  item = null
  own = false
  name = ''
  folder_id = 0
  folder_name = ''
  campaign = {
    id: 0,
    name: '',
    starts: '',
    ends: ''
  }
  owner = ''
  status = ''
  language = ''
  dispatch_datetime = ''
  dispatch_date = ''
  dispatch_time = ''
  subject = ''
  from = ''
  mail_template = null
  html_link = ''
  text_link = ''
  unsubscribe_link = null
  recipients = []
  recipientsCount = {
    all: 0,
    unique: 0
  }
  duplicates_allowed = false

  map(res) {
    const mailing = res.mailing
    this.id = mailing._attributes.id || ''
    this.item = mailing._attributes.id || ''
    this.name = mailing._attributes.name || ''
    this.campaign = store.getters.getCampaignById(mailing._attributes.campaign_id || 0)
    this.owner = store.getters.getAccountById(mailing._attributes.user_id || 0) // TODO: parse
    this.status = mailing._attributes.status || ''
    this.language = mailing._attributes.lang || 0
    this.dispatch_datetime = dateToISO(mailing.dispatch_datetime._text || '')
    this.subject = mailing.subject._text || ''
    this.from = mailing.from._text || ''
    this.mail_template = mailing.mail_template ? mailing.mail_template._attributes || null : null             // map entire object
    this.html_link = mailing.html_link ? mailing.html_link._text || null : null
    this.text_link = mailing.text_link ? mailing.text_link._text || null : null
    this.unsubscribe_link = mailing.unsubscribe_link ? mailing.unsubscribe_link._attributes || null : null    // map entire object
    let recipients = mailing.recipients && mailing.recipients.recipient ? (mailing.recipients.recipient.length ? mailing.recipients.recipient : [mailing.recipients.recipient]) : []
    this.recipients = recipients.map(a => ({ ...a._attributes, value: a._attributes.id, text: a._attributes.name }))
    this.recipientsCount.all = +mailing._attributes.all_recipients || 0
    this.recipientsCount.unique = +mailing._attributes.unique_recipients || 0
    this.duplicates_allowed = !!+mailing.duplicates_allowed._text || false

    this.own = (mailing._attributes.user_id == res._attributes.user_id) || store.getters.is_admin
    this.folder_id = this.campaign.folder_id

    if (mailing._attributes.folder_id) {
      this.folder_id = mailing._attributes.folder_id
      this.folder_name = mailing._attributes.folder_name
    }
    return this
  }
}
